import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';
import { studentFeesKeys } from '../studentFees/keys';

const studentsKeys = <T extends QueryKey>(keys: T) => {
  return createQueryKey({
    all: [...keys, 'students'] as const,
    id: <U extends QueryKeyParam>(studentId: U) =>
      createQueryKey({
        all: [...keys, 'students', studentId] as const,
        fees: studentFeesKeys([...keys, 'students', studentId]),
      }),
  });
};

export { studentsKeys };
